import { CountryModel } from "src/app/models/common/countrymodel";
import { StateNestedModel } from "src/app/models/common/statemodel";

export class QuickAddCompanyError {
    name: string[];
    country: string[];
    state: string[];
    address: string[];
}
export class QuickAddCompanyModel {
    name: string;
    country: CountryModel;
    state: StateNestedModel;
    address: string;
    is_b2c:boolean;

    error: QuickAddCompanyError;

    constructor() {
        this.name = null;
        this.country = null;
        this.state = null;
        this.address = null;
        this.is_b2c=false;

        this.resetCompanyErrors();
    }

    resetCompanyErrors() {
        this.error = {
            name: [],
            country: [],
            state: [],
            address: [],
        }
    }

    saveCompanyPayloadToModel(data) {
        this.name = data.name;
        this.country = data.country;
        this.state = data.state;
        this.address = data.address;
        this.is_b2c = data.is_b2c;
    }

    getCompanySavePayload() {
        return {
            name: this.name,
            country: typeof this.country == 'object' && this.country != null ? this.country.id : this.country,
            state: typeof this.state == 'object' && this.state != null ? this.state.id : this.state,
            address: this.address,
            is_b2c: this.is_b2c,
        }
    }

    is_company_valid() {
        this.resetCompanyErrors();

        if (this.name == null || this.name == '') {
            this.error.name = ['Company name is required'];
        }
        if (this.name.length < 3 && this.name.length > 0) {
            this.error.name = ['Company Name should be minimum of 3 characters'];
        }
        if (this.country == null) {
            this.error.country.push('Country is required');
        }
        if (this.state == null) {
            this.error.state.push('State is required');
        }
        if (this.address == null) {
            this.error.address.push('Address is required');
        }

        return this.error.name.length == 0 &&
            this.error.country.length == 0 && this.error.state.length == 0 && this.error.address.length == 0
    }
}
